import { ContactEmailRecipient } from '@core/models/deploy-plan-config.model';
import { escapeHtml } from '@core/utils/html-escape.utils';

/**
 * The hover reveal of a message's recipients, for the tooltip singleton's `[innerHTML]`.
 * Contact names come from customer data, so every value is escaped.
 */
export function buildRecipientsTooltipHtml(recipients: ContactEmailRecipient[]): string {
  const rows = recipients.map((recipient) => {
    const email = `<span class="font-mono text-xs opacity-75">${escapeHtml(recipient.email)}</span>`;
    const name = recipient.name?.trim();
    return name
      ? `<div class="flex flex-col"><span class="font-medium">${escapeHtml(name)}</span>${email}</div>`
      : `<div class="flex flex-col">${email}</div>`;
  });

  return `<div class="flex flex-col gap-1.5">${rows.join('')}</div>`;
}
